/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_DescriptionInputs */

const en_directory_mcp_description = /** @type {(inputs: Directory_Mcp_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One remote MCP server, one project token, eight tools that mirror the REST API exactly.`)
};

const zh_directory_mcp_description = /** @type {(inputs: Directory_Mcp_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一个远程 MCP 服务器、一个项目令牌、八个与 REST API 完全对等的工具。`)
};

/**
* | output |
* | --- |
* | "One remote MCP server, one project token, eight tools that mirror the REST API exactly." |
*
* @param {Directory_Mcp_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_description = /** @type {((inputs?: Directory_Mcp_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_description(inputs)
	return zh_directory_mcp_description(inputs)
});
export { directory_mcp_description as "directory.mcp.description" }